import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { ReactiveFormsModule } from "@angular/forms";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";

import { EcertInputComponent } from "./ecertnl-input/ecertnl-input.component";
import { IconComponent } from "./ecertnl-icon/ecertnl-icon.component";
import { EcertSelectComponent } from "./ecertnl-select/ecertnl-select.component";
import { CovHeaderComponent } from "./componenten/cov-header/cov-header.component";

import { GlobalServicesModule } from "../global_services/global-services.module";

@NgModule({
  declarations: [
    EcertInputComponent,
    IconComponent,
    EcertSelectComponent,
    CovHeaderComponent,
  ],
  exports: [
    EcertInputComponent,
    IconComponent,
    EcertSelectComponent,
    CovHeaderComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    GlobalServicesModule,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class BuildingBlocksModule {}
